import { render, staticRenderFns } from "./LayoutSimple.vue?vue&type=template&id=dca4e45e"
import script from "./LayoutSimple.vue?vue&type=script&lang=ts"
export * from "./LayoutSimple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports